export const accurateQuantifier = (value, quantifier) => {
  const accurateQuantifier = `${value} ${quantifier}`;
  if (parseInt(value) === 1) {
    return accurateQuantifier;
  } else {
    return accurateQuantifier + "s";
  }
};
